import ConfirmationModal from './Confirmation'
export default ConfirmationModal
